import {TextField , withStyles} from "@material-ui/core";

export default withStyles({
    root: {
        '& .MuiInputLabel-formControl':{
            right:'0',
            left: 'unset'
        },
        '& .MuiInputBase-root':{
            color:'#fff'
        },
        '& .MuiFormLabel-root':{
            color: '#fff'
        },
        '& label.Mui-focused': {
          color: '#ff',
        },
        '& .MuiInput-underline:before': {
          borderBottomColor: '#fff',
        },
       '& .MuiInput-underline:hover:not(.Mui-disabled):before':{
        borderBottom: '2px solid rgba(255, 255, 255, 0.87)'
       }
        
      },
  })(TextField);